import dayjs from 'dayjs';
import React from 'react';

import { Carriers } from '../../../../../common/constants/carriers';
import Letter from '../generator/components/Letter';
import {
  LETTER_DEFAULT_EMAIL,
  LETTER_DEFAULT_PHONE,
} from '../generator/constants';
import { LetterTypes, Sources } from '../generator/types';

import {
  buildLetterParagraphs,
  collectFieldPlaceholders,
  resolveOrderedBlocks,
} from './letterBodyBuilder';
import { PdfMarkerText } from './PdfMarkerText';
import { PricingMode } from './types';

export interface DrawerPdfLetterProps {
  letterType: LetterTypes;
  pricingMode: PricingMode;
  isJuvenile: boolean;
  carrier: Carriers;
  carrierDisplayName: string;
  policyNumber: string;
  recipientFullName: string;
  proposedInsuredName: string;
  riders: string[];
  selectedRiders: string[];
  selectedSources: Sources[];
  fieldValues: Record<string, string>;
  hasFcra: boolean;
}

export const DrawerPdfLetter = (props: DrawerPdfLetterProps) => {
  const { orderedBlocks } = resolveOrderedBlocks(
    props.letterType,
    props.pricingMode,
    props.selectedSources,
  );
  const placeholders = collectFieldPlaceholders(orderedBlocks);

  const body = buildLetterParagraphs(
    {
      letterType: props.letterType,
      pricingMode: props.pricingMode,
      isJuvenile: props.isJuvenile,
      selectedSources: props.selectedSources,
      selectedRiders: props.selectedRiders,
      fieldValues: props.fieldValues,
    },
    { allowOverrides: true },
  );

  return (
    <Letter
      fullName={props.recipientFullName}
      date={dayjs().format('YYYY-MM-DD')}
      carrier={props.carrier}
      email={LETTER_DEFAULT_EMAIL}
      phone={LETTER_DEFAULT_PHONE}
      policyNumber={props.policyNumber}
      isJuvenile={props.isJuvenile}
      insuredName={props.proposedInsuredName}
    >
      {body.map((para, idx) => (
        <React.Fragment key={idx}>
          <PdfMarkerText
            text={para.text}
            fieldValues={props.fieldValues}
            fieldPlaceholders={placeholders}
            riders={props.selectedRiders}
            carrierDisplayName={props.carrierDisplayName}
            blockId={para.blockId}
          />
          {para.contact ? (
            <PdfMarkerText
              text={para.contact}
              fieldValues={props.fieldValues}
              fieldPlaceholders={placeholders}
              riders={props.selectedRiders}
              carrierDisplayName={props.carrierDisplayName}
              blockId={para.blockId}
            />
          ) : null}
        </React.Fragment>
      ))}
    </Letter>
  );
};

export { collectFieldPlaceholders } from './letterBodyBuilder';
